import { switchTabsOnHover } from '../actions/timePanelDndStoreActions';
import { setLastEnterCalendarTab, setLastEnterTasksTab } from '../actions/timePanelDndStoreActions';
import { doNothingOnDrop } from '../utils/doNothingOnDrop';
import { IPivotItemProps } from 'office-ui-fabric-react/lib/Pivot';
import { addMilliseconds, compare, now } from 'owa-datetime';
import { DragData, Droppable } from 'owa-dnd';
import { getCurrentPanelView } from 'owa-time-panel-settings';
import * as React from 'react';
import {
    getCalendarTabDropState,
    getLastDragOverCalendarTab,
    getLastDragOverTasksTab,
    getTasksTabDropState,
    shouldShowCalendarTabHoverHint,
    shouldShowTasksTabHoverHint,
} from '../selectors/timePanelDndStoreSelectors';

const styles = require('./TimePanelDndPivotItem.scss');
const classNames = require('classnames');

const HOVER_WAIT_TIME = 500;

export function getCalendarPivotStyles(): string {
    return classNames(
        { [styles.pivotItemDropContainer]: shouldShowCalendarTabHoverHint() },
        { [styles.pivotItemDropContainerActive]: getCalendarTabDropState().isDragOver }
    );
}

export function getTasksPivotStyles(): string {
    return classNames(
        { [styles.pivotItemDropContainer]: shouldShowTasksTabHoverHint() },
        { [styles.pivotItemDropContainerActive]: getTasksTabDropState().isDragOver }
    );
}

export function renderDroppableCalendarPivot(
    link: IPivotItemProps,
    defaultRenderer: (link: IPivotItemProps) => JSX.Element
): JSX.Element {
    return (
        <Droppable
            dropViewState={getCalendarTabDropState()}
            onDrop={doNothingOnDrop}
            onDragEnter={startHoverCalendarTab}
            onDragOver={openCalendarAfterHover}>
            <div className={getCalendarPivotStyles()}>{defaultRenderer(link)}</div>
        </Droppable>
    );
}

export function renderDroppableTasksPivot(
    link: IPivotItemProps,
    defaultRenderer: (link: IPivotItemProps) => JSX.Element
): JSX.Element {
    return (
        <Droppable
            dropViewState={getTasksTabDropState()}
            onDrop={doNothingOnDrop}
            onDragEnter={startHoverTasksTab}
            onDragOver={openTasksAfterHover}>
            <div className={getTasksPivotStyles()}>{defaultRenderer(link)}</div>
        </Droppable>
    );
}

function openCalendarAfterHover(): void {
    if (compare(addMilliseconds(getLastDragOverCalendarTab(), HOVER_WAIT_TIME), now()) <= 0) {
        switchTabsOnHover(getCurrentPanelView(), 'Calendar');
    }
}

function openTasksAfterHover(): void {
    if (compare(addMilliseconds(getLastDragOverTasksTab(), HOVER_WAIT_TIME), now()) <= 0) {
        switchTabsOnHover(getCurrentPanelView(), 'Tasks');
    }
}

function startHoverCalendarTab(dragInfo: DragData): void {
    setLastEnterCalendarTab(now());
}

function startHoverTasksTab(dragInfo: DragData): void {
    setLastEnterTasksTab(now());
}
